import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { FundraiserSubsequentInfo } from "../../Interfaces/Fundraiser";

import person_icon from "../../images/ProgressBarIcons/complete_icons/Personal.png";
import shipping_icon from "../../images/ProgressBarIcons/complete_icons/Shipping.png";
import credit_card from "../../images/ProgressBarIcons/complete_icons/Payment.png";
import review_icon from "../../images/ProgressBarIcons/complete_icons/Review.png";
import heart_icon from "../../images/ProgressBarIcons/incomplete_icons/Thanks.png";
import AssignParticipants from "../../components/Forms/StartingYourFundraiser/Step4-AssignParticipants/AssignParticipants";

const FundraiserAssignParticipants = () => {
    const progress_bar_props = [
    { icon: person_icon, label: "Organization Info" },
    { icon: shipping_icon, label: "Fundraiser Info" },
    { icon: credit_card, label: "Primary/Secondary" },
    { icon: review_icon, label: "Assign Participants" },
    { icon: heart_icon, label: "Review & Create" },
  ];
  const currentStep = 4;

  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    document.title = "Create Your Fundraiser";
  }, []);

    if (!state) {
      return <div>The fundraiser ID has not been properly provided.</div>;
    }
  const fundraiser_props: FundraiserSubsequentInfo = {
    "fundraiserID": state.fundraiserID,
    "teamAdminName": null,
    "primaryDivisionName": null,
    "secondaryDivisionName": null
  }

    return(    <div className="create-fundraiser-assign-participant-page">
      <div className="progress-bar">
        <ProgressBar steps={progress_bar_props} currentStep={currentStep} />
      </div>
      <AssignParticipants {...fundraiser_props}/>
    </div>)
}

export default FundraiserAssignParticipants